module.exports = __webpack_public_path__ + "img/6_35.39f4d8d8.png";